import getLangRoute from '~/utils/getCurrentRoute'

export default async (context) => {
  const [lang, path] = getLangRoute(context.route)

  await context.store.dispatch('loadData', {
    lang,
    path,
  })
}
